module.exports = __webpack_public_path__ + "static/media/portfolioHeaderImg.40d2ba3c.png";